import { Grid } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useAppSelector } from "../redux/hooks";
import { useEffect, useState } from "react";
import MemberTab from "../components/ui/TabSection";
import { LoyaltyPoints } from "../components/member/LoyaltyPoints";
import MemberReceiptTab from "./MemberReceiptTab";
import useGetCarparkBalance from "../Hooks/carpark/useGetCarparkBalance";
import MemberDetailsHeaderNew from "../components/member/MemberDetailsHeaderNew";
import EvoucherTabNew from "../components/member/EvoucherTabNew";
import { usePermissionGetter } from "../Hooks/Permissions/userPermissionGetter";
import { permissionsConstants } from "../constants/AppConstants";

const MemberRedemption = () => {
  const { getUserPermission:getReceiptsPermissions} = usePermissionGetter(
    permissionsConstants.member_redemption,
    permissionsConstants.receipts
  );
  const { getUserPermission:getEVoucherPermissions} = usePermissionGetter(
    permissionsConstants.member_redemption,
    permissionsConstants.evouchers
  );
  const { getUserPermission:getPointsPermissions} = usePermissionGetter(
    permissionsConstants.member_redemption,
    permissionsConstants.points
  );
  const tabList = [
    { title: "Receipts", feature: "Receipts" },
    { title: "e-Voucher", feature: "Vouchers" },
    { title: "Loyalty Points", feature: "Points" },
  ];
  const [activeMemberTab, setActiveMemberTab] = useState<string>(
    tabList[0].title
  );
  const theme = useTheme();
  const memberDetails = useAppSelector(
    (state: any) => state.persistReducers.getMemberList?.membersList
  );
  const loyaltyPoints = useAppSelector(
    (state: any) => state.persistReducers.pointsSlice.points
  );
  const { getCarparkBalance, balance } = useGetCarparkBalance();
  useEffect(() => {
    getCarparkBalance(memberDetails);
  }, []);

  const handleTabSwitch = (key: string) => {
    switch (key) {
      case "Receipts":
        return (
          <Grid p={2} height={"100%"}>
            {getReceiptsPermissions("read") && <MemberReceiptTab />}
          </Grid>
        );

      case "e-Voucher":
        return (
          <Grid p={2}>
            {getEVoucherPermissions("read") && <EvoucherTabNew />}
          </Grid>
        );
      case "Loyalty Points":
        return (
          <Grid p={2} item>
            {getPointsPermissions("read") && (
              <LoyaltyPoints
                loyaltyPointsValue={
                  memberDetails && memberDetails.loyaltyPoints
                }
                formData={memberDetails.email}
              />
            )}
          </Grid>
        );
    }
  };

  return (
    <>
      <Grid display={"flex"} gap={2}>
        <Grid
          display={"flex"}
          justifyContent={"center"}
          alignItems={"start"}
          height={"100%"}
          width={"25%"}
        >
          <MemberDetailsHeaderNew
            pointsValidityData={memberDetails && memberDetails.expirySchedules}
            expiryDate={memberDetails && memberDetails.expiry_points_date}
            nextSlab={memberDetails && memberDetails.nextSlab}
            expiryPoints={memberDetails && memberDetails.expiry_points}
            email={memberDetails && memberDetails.email}
            memberSince={memberDetails && memberDetails.join_date}
            memberName={
              memberDetails && memberDetails.first_name
                ? `${memberDetails.first_name} ${memberDetails.last_name}`
                : "-"
            }
            memberTier={memberDetails && memberDetails.currentSlab}
            slabExpiryDate={memberDetails && memberDetails.slabExpiryDate}
            loyaltyNo={memberDetails && memberDetails.loyaltyId}
            status={
              memberDetails && memberDetails.customer_status
                ? memberDetails.customer_status
                : "-"
            }
            loyaltyPoints={
              loyaltyPoints > 0 ? loyaltyPoints : memberDetails.loyaltyPoints
            }
            carpark={balance ? balance : "0"}
            min_purchase_value_required={
              memberDetails && memberDetails.min_purchase_value_required
            }
            currentSlab={memberDetails && memberDetails.currentSlab}
            gap_to_upgrade={memberDetails && memberDetails.gap_to_upgrade}
            upgrade_by={memberDetails && memberDetails.upgrade_by}
            gap_to_renew={memberDetails && memberDetails.gap_to_renew}
            renew_by={memberDetails && memberDetails.renew_by}
            yuu_status={memberDetails && memberDetails?.yuu_linking_status}
            show_yuu ={false}
          />
        </Grid>
        <Grid
          width={"75%"}
          sx={{
            background: theme.color?.background,
            borderRadius: 4,
          }}
          overflow={"hidden"}
        >
          <Grid
            sx={{ backgroundColor: theme?.color?.background }}
            display={"flex"}
            height={"8vh"}
            borderBottom={`${theme?.border?.xsmall} ${theme?.color?.dividerLight}`}
            pl={2}
          >
            <MemberTab
              tabList={tabList}
              setParentTabState={setActiveMemberTab}
            />
          </Grid>
          <Grid height={"90%"}>{handleTabSwitch(activeMemberTab)}</Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default MemberRedemption;
